import {
  LinearProgress,
  Step,
  StepContent,
  StepLabel,
  Stepper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AlertBox from "../../component/AlertBox";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import InputField from "../../component/InputField";
import ButtonCompo from "../../component/ButtonCompo";
import SelectField from "../../component/SelectField";
import axios from "axios";
import { SERVER_URL } from "../../constant";

function NewHiringReq() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.hiringReq === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [activeStep, setActiveStep] = useState(0);

  // input hooks
  const [role, setRole] = useState("");
  const [position, setPosition] = useState("");
  const [yoe, setYoe] = useState("");
  const [skills, setSkills] = useState("");
  const [eligibility, setEligibility] = useState("");
  const [jobDesc, setJobDesc] = useState("");
  const [joiningDuration, setJoiningDuration] = useState("");

  const handleFwdStep = () => setActiveStep((prev) => prev + 1);
  const handleBckStep = () => setActiveStep((prev) => prev - 1);
  const handleReset = () => setActiveStep(0);

  // apply for leave
  async function createHiringReq() {
    if (
      role?.length === 0 ||
      position?.length === 0 ||
      yoe === 0 ||
      skills === 0 ||
      eligibility === 0 ||
      jobDesc === 0 ||
      eligibility === 0
    ) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please fill all the field");
      return null;
    }
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/hiring/request/add`,
        method: "post",
        data: {
          role: role,
          skills: skills,
          yearsOfExperience: yoe,
          position: position,
          eligibility: eligibility,
          jobDescription: jobDesc,
          expectedJoiningDuration: joiningDuration,
        },
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setOpen(true);
        setSuccess(true);
        setMessage("Hiring request has been raised successfully");
        navigate("/admin/all/request/hiring")
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(
        error?.response?.data?.message || "Hiring request raise failed"
      );
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const joiningDurationArray = [
    {
      title: "15 Days",
      value: "15 Days",
    },
    {
      title: "30 Days",
      value: "30 Days",
    },
    {
      title: "60 Days",
      value: "60 Days",
    },
    {
      title: "90 Days",
      value: "90 Days",
    },
  ];

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            New Hiring Request
          </h1>
          <div className="mt-5 w-full">
            <div className="w-full xl:w-[70rem]">
              <Stepper activeStep={activeStep} orientation="vertical">
                <Step className="!w-full">
                  <StepLabel>
                    <p
                      className={`text-[17px] ${
                        activeStep === 0
                          ? "text-slate-700 font-medium"
                          : "text-slate-500 font-normal"
                      }`}
                    >
                      Role & Position
                    </p>
                  </StepLabel>
                  <StepContent>
                    <div className="mt-3">
                      <section className="grid grid-cols-2 gap-5">
                        <InputField
                          onChange={(eve) => setRole(eve?.target?.value)}
                          label="Role"
                          required
                        />
                        <InputField
                          onChange={(eve) => setPosition(eve?.target?.value)}
                          label="Position"
                          required
                        />
                      </section>
                      <section className="mt-5">
                        <ButtonCompo
                          variant={"contained"}
                          onClick={handleFwdStep}
                        >
                          Continue
                        </ButtonCompo>
                      </section>
                    </div>
                  </StepContent>
                </Step>
                <Step className="!w-full">
                  <StepLabel>
                    <p
                      className={`text-[17px] ${
                        activeStep === 1
                          ? "text-slate-700 font-medium"
                          : "text-slate-500 font-normal"
                      }`}
                    >
                      Years of Experience
                    </p>
                  </StepLabel>
                  <StepContent>
                    <div className="mt-3">
                      <section className="">
                        <InputField
                          label="Years of Experience"
                          required
                          helperText="Absolute year or year range (E.g, 2, 3, 1-3 etc)"
                          onChange={(eve) => setYoe(eve?.target?.value)}
                        />
                      </section>
                      <section className="mt-5 flex items-center justify-between">
                        <section className="flex items-center gap-5">
                          <ButtonCompo
                            variant={"contained"}
                            onClick={handleFwdStep}
                          >
                            Continue
                          </ButtonCompo>
                          <ButtonCompo onClick={handleBckStep}>
                            Back
                          </ButtonCompo>
                        </section>
                        <ButtonCompo onClick={handleReset}>
                          Go To Step 1
                        </ButtonCompo>
                      </section>
                    </div>
                  </StepContent>
                </Step>
                <Step className="!w-full">
                  <StepLabel>
                    <p
                      className={`text-[17px] ${
                        activeStep === 2
                          ? "text-slate-700 font-medium"
                          : "text-slate-500 font-normal"
                      }`}
                    >
                      Eligibility
                    </p>
                  </StepLabel>
                  <StepContent>
                    <div className="mt-3">
                      <section className="">
                        <InputField
                          label="Eligibility"
                          onChange={(eve) => setEligibility(eve?.target?.value)}
                          required
                          multiline
                        />
                      </section>
                      <section className="mt-5 flex items-center justify-between">
                        <section className="flex items-center gap-5">
                          <ButtonCompo
                            variant={"contained"}
                            onClick={handleFwdStep}
                          >
                            Continue
                          </ButtonCompo>
                          <ButtonCompo onClick={handleBckStep}>
                            Back
                          </ButtonCompo>
                        </section>
                        <ButtonCompo onClick={handleReset}>
                          Go To Step 1
                        </ButtonCompo>
                      </section>
                    </div>
                  </StepContent>
                </Step>
                <Step className="!w-full">
                  <StepLabel>
                    <p
                      className={`text-[17px] ${
                        activeStep === 3
                          ? "text-slate-700 font-medium"
                          : "text-slate-500 font-normal"
                      }`}
                    >
                      Skills
                    </p>
                  </StepLabel>
                  <StepContent>
                    <div className="mt-3">
                      <section className="">
                        <InputField
                          label="Skills"
                          onChange={(eve) => setSkills(eve?.target?.value)}
                          required
                          multiline
                        />
                      </section>
                      <section className="mt-5 flex items-center justify-between">
                        <section className="flex items-center gap-5">
                          <ButtonCompo
                            variant={"contained"}
                            onClick={handleFwdStep}
                          >
                            Continue
                          </ButtonCompo>
                          <ButtonCompo onClick={handleBckStep}>
                            Back
                          </ButtonCompo>
                        </section>
                        <ButtonCompo onClick={handleReset}>
                          Go To Step 1
                        </ButtonCompo>
                      </section>
                    </div>
                  </StepContent>
                </Step>
                <Step className="!w-full">
                  <StepLabel>
                    <p
                      className={`text-[17px] ${
                        activeStep === 4
                          ? "text-slate-700 font-medium"
                          : "text-slate-500 font-normal"
                      }`}
                    >
                      Expected Joining Duration
                    </p>
                  </StepLabel>
                  <StepContent>
                    <div className="mt-3">
                      <section className="">
                        <SelectField
                          label={"Joining Duration"}
                          value={joiningDuration}
                          setValue={(eve) =>
                            setJoiningDuration(eve?.target?.value)
                          }
                          valueArray={joiningDurationArray}
                        />
                      </section>
                      <section className="mt-5 flex items-center justify-between">
                        <section className="flex items-center gap-5">
                          <ButtonCompo
                            variant={"contained"}
                            onClick={handleFwdStep}
                          >
                            Continue
                          </ButtonCompo>
                          <ButtonCompo onClick={handleBckStep}>
                            Back
                          </ButtonCompo>
                        </section>
                        <ButtonCompo onClick={handleReset}>
                          Go To Step 1
                        </ButtonCompo>
                      </section>
                    </div>
                  </StepContent>
                </Step>
                <Step className="!w-full">
                  <StepLabel>
                    <p
                      className={`text-[17px] ${
                        activeStep === 4
                          ? "text-slate-700 font-medium"
                          : "text-slate-500 font-normal"
                      }`}
                    >
                      Job Description
                    </p>
                  </StepLabel>
                  <StepContent>
                    <div className="mt-3">
                      <section className="">
                        <InputField
                          label="Job Description"
                          required
                          multiline
                          rows={10}
                          onChange={(eve) => setJobDesc(eve?.target?.value)}
                        />
                      </section>
                      <section className="mt-5 flex items-center justify-between">
                        <section className="flex items-center gap-5">
                          <ButtonCompo onClick={handleBckStep}>
                            Back
                          </ButtonCompo>
                          <ButtonCompo
                            variant={"contained"}
                            onClick={createHiringReq}
                          >
                            Send Request
                          </ButtonCompo>
                        </section>
                        <ButtonCompo onClick={handleReset}>
                          Go To Step 1
                        </ButtonCompo>
                      </section>
                    </div>
                  </StepContent>
                </Step>
              </Stepper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewHiringReq;
